import {normalize} from 'normalizr';

import api from '../../api';
import {schema} from '../../schema';
import {addEntities} from '../../actions';
import Logger from '../../../lib/Logger';

export const TYPES = {
  LIST_REQUEST: 'RESOURCE_SERVICE_TAGS/LIST_REQUEST',
  LIST_SUCCESS: 'RESOURCE_SERVICE_TAGS/LIST_SUCCESS',
  LIST_FAILURE: 'RESOURCE_SERVICE_TAGS/LIST_FAILURE',
};

export function resourceServiceTagListRequest(page, limit, order, filter) {
  Logger.log('debug', `[state.resourceServiceTags.actions] resourceServiceTagListRequest(${page}, ${limit}, ${order}, %j)`, filter);
  return {
    type: TYPES.LIST_REQUEST,
    page: page,
    limit: limit,
    order: order,
    filter: filter,
  }
}

export function resourceServiceTagListSuccess(data) {
  Logger.log('debug', `[state.resourceServiceTags.actions] resourceServiceTagListSuccess(%j)`, data);
  return {
    type: TYPES.LIST_SUCCESS,
    page: data.page,
    limit: data.limit,
    order: data.order,
    result: data.result,
    total: data.total,
    receivedAt: Date.now()
  }
}

export function resourceServiceTagListFailure(error) {
  Logger.log('debug', `[state.resourceServiceTags.actions] resourceServiceTagListFailure( %j)`, error);
  return {
    type: TYPES.LIST_FAILURE,
    error: error
  }
}


// API THUNK ACTION CREATORS

export function loadResourceServiceTags(page=1, limit=10, order=null, filter=null, cb=function(){}) {
  Logger.log('debug', `[state.resourceServiceTags.actions] loadResourceServiceTags(${page}, ${limit}, ${order}, %j, ###)`, filter);

  return async function(dispatch) {
    dispatch(resourceServiceTagListRequest(page, limit, order, filter));

    // call API
    const response = await api.getResourceServiceTags(page, limit, order, filter);
    let success = false;

    // get Resource Service Tags list success
    if (200 === response.get('status')) {

      Logger.log('info', `Get API Resource Service Tags list success. Page: ${page}, Limit: ${limit}, Order: ${order}.`);

      const normalizedEntities = normalize(response.getIn(['data', 'resource_service_tags']), [schema.resourceServiceTag]);
      const data = {
        page: response.getIn(['data', 'page']),
        limit: response.getIn(['data', 'limit']),
        order: order,
        total: response.getIn(['data', 'total']),
        result: normalizedEntities.result
      };

      dispatch(addEntities(normalizedEntities));
      dispatch(resourceServiceTagListSuccess(data));
      success = true;

    } else if (1 === page && 204 === response.get('status')) {

      Logger.log('info', `Get API Resource Service Tags list success [empty]. Page: ${page}, Limit: ${limit}, Order: ${order}.`);
      const data = {
        page: page,
        limit: limit,
        order: order,
        total: 0,
        result: []
      };
      dispatch(resourceServiceTagListSuccess(data));
      success = true;
      
    // get Care Resource Service Tags list failure
    } else {
      Logger.log('info', `Get API Resource Service Tags list failure. Page: ${page}, Limit: ${limit}, Order: ${order}.`);
      dispatch(resourceServiceTagListFailure(response.getIn(['data', 'error'])));
    }

    // callback function
    cb(success);
  }
}

Logger.log('silly', `state.resourceServiceTags.actions loaded.`);
